(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dm-clone-pdp-rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-dm-scroll-reviews]');
    if (!link) return;
    const target = document.querySelector('kov-reviews.dm-reviews');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
